export const TRAVEL_DESTINATIONS_SEARCH = 'TRAVEL_DESTINATIONS_SEARCH';
export const TRAVEL_DESTINATIONS_SEARCH_RESULT = 'TRAVEL_DESTINATIONS_SEARCH_RESULT';
export const TRAVEL_DEPARTURE_SEARCH = 'TRAVEL_DEPARTURE_SEARCH';
export const TRAVEL_DEPARTURE_SEARCH_RESULT = 'TRAVEL_DEPARTURE_SEARCH_RESULT';
export const TRAVEL_LOCATIONS = 'TRAVEL_LOCATIONS';
export const TRAVEL_LOCATIONS_SUCCESS = 'TRAVEL_LOCATIONS_SUCCESS';
export const TRAVEL_LOCATIONS_FAILED = 'TRAVEL_LOCATIONS_FAILED';
export const SET_SUGGESTED_DEPARTURE_LOCATION = 'SET_SUGGESTED_DEPARTURE_LOCATION';
export const SET_SUGGESTED_FURTHEST_DESTINATION = 'SET_SUGGESTED_FURTHEST_DESTINATION';

export interface TravelLocations {
  iata: string;
  name: string;
  city?: string;
  state?: string;
  country: string;
}

export interface TravelDepartureDestinations {
  departure?: TravelLocations[];
  destinations?: TravelLocations[];
  suggestedDepartureLocation?: TravelLocations[];
  suggestedFurthestDestination?: TravelLocations[];
  retrievePending?: boolean;
  loading?: boolean;
  error?: unknown;
  response?: TravelLocations[];
}
